<template>
  <img :src="path" />
</template>

<script>
export default {
  name: "iImg",
  props: {
    src: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
  },
  computed: {
    path() {
      return /^http/.test(this.src)
        ? this.src
        : this.cloudPic + "/" + this.type + "/" + this.src;
    },
  },
};
</script>

<style scoped></style>